import React, { useEffect } from 'react';
import '@sendbird/uikit-react/dist/index.css';
import Page from 'modules/app/components/Page';
import useIsAuth from 'sdk/hooks/useIsAuth';
import { useGetMyUser } from 'sdk/hooks/user/useGetMyUser';

// Добавляем глобальное объявление Intercom
declare global {
    interface Window {
        Intercom: any;
    }
}

const SendBird = () => {
    const { data: isAuthData } = useIsAuth();
    const userId = isAuthData?.user?.id;
    const { data: user } = useGetMyUser(userId ?? '')

    useEffect(() => {
        if (!window.Intercom) {
            const script = document.createElement("script");
            script.src = "https://widget.intercom.io/widget/cez7qw6h";
            script.async = true;
            document.body.appendChild(script);
            script.onload = () => {
                initIntercom();
            };
        } else {
            initIntercom();
        }

        return () => {
            window.Intercom?.("shutdown");
        };
    }, [user]);

    const initIntercom = () => {
        if (user) {
            window.Intercom("boot", {
                app_id: "cez7qw6h",
                user_id: user.id,
                name: user.username,
                email: user.email,
                created_at: Math.floor(new Date(user.created_at).getTime() / 1000),
            });

            setTimeout(() => {
                window.Intercom("update", {
                    email: user.email,
                    user_id: user.id,
                    name: user.aud
                });
            }, 3000);

            window.Intercom("show"); // Показываем чат
        }
    };

    return (
        <Page activeLink="/venues">
            <div>
                <button onClick={() => window.Intercom("show")}>Открыть чат</button>
            </div>
        </Page>
    );
};

export default SendBird;
